<template>
  <div class="details-wrapper">
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <ContractorDetailsForm :contractor="newContractor" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContractorDetailsForm from '../contractor-details/components/ContractorDetailsForm';
import { AppActions } from '@/app/app.keys';
import { NewContractorGetters } from '../../features/new-contractor/new-contractor.keys';

export default {
  name: 'ContractorDetails',
  components: { ContractorDetailsForm },

  computed: {
    newContractor() {
      return this.$store.getters[NewContractorGetters.NewContractor];
    }
  },

  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('contractor.labels.newContractor'));
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;
  .details-header {
    display: flex;

    padding: $details-padding;
    border-bottom: 2px solid $row-border;
    justify-content: space-between;
  }

  .details-body {
    position: relative;

    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }

    .details-section {
      padding-bottom: 25px;

      h1 {
        border-bottom: 1px solid $row-border;
      }
    }
  }
}
</style>
